import { find } from 'lodash';
import { EpsData } from 'src/devices/payment/dtos/eps-data';
import { EmeraldError } from '../../common/api/emerald-error';
import { TenderType } from '../../common/enumerations/tender-type';
import { ITender } from '../../common/interfaces/dtos/ITender';
import { store } from '../../common/redux/configure-store';
import { isEwic } from './process-ewic-tender';

export const getTenderByEpsData = (epsData?: EpsData): ITender => {
  const rawTenders: ITender[] = store.getState().tenderMenu.sellableTenders.rawTenders;
  const defaultEFTTender =
    getEwicTender(rawTenders, epsData) ??
    find(rawTenders, tender => tender.description === epsData?.card.cardName) ??
    find(rawTenders, tender => !!tender.tenderReferences?.includes(epsData?.card.cardCode ?? '')) ??
    find(rawTenders, tender => tender.type === TenderType.CreditDebit);

  if (!defaultEFTTender) {
    throw new EmeraldError('No_Tenders', 'EFT Tender unavailable');
  }

  return defaultEFTTender;
};

const getEwicTender = (rawTenders: ITender[], epsData?: EpsData): ITender | undefined => {
  if (!epsData) {
    return undefined;
  }
  return rawTenders.find(tender => isEwic(tender, epsData));
};
